module.exports = __webpack_public_path__ + "media/images/product_large_images/paper-5f88c7cb2256bd1e08fc7ba620152ec8.png";